import { render, staticRenderFns } from "./GenericBulkUpload.vue?vue&type=template&id=42273b28&scoped=true"
import script from "./GenericBulkUpload.vue?vue&type=script&lang=js"
export * from "./GenericBulkUpload.vue?vue&type=script&lang=js"
import style0 from "./GenericBulkUpload.vue?vue&type=style&index=0&id=42273b28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42273b28",
  null
  
)

export default component.exports